import '@nettbureau/theme';
import 'radash';
import { parseHeight } from '../parsers/height.js';
import 'polished';
import { parseWidth } from '../parsers/width.js';

/**
 * Generates CSS for applying dimensions to an element.
 *
 * @param options - Options for the mixin.
 */ function size(options) {
    const { height, minHeight, maxHeight, width, minWidth, maxWidth } = options;
    return (theme)=>[
            height !== undefined && {
                height: parseHeight(theme, height)
            },
            minHeight !== undefined && {
                minHeight: parseHeight(theme, minHeight)
            },
            maxHeight !== undefined && {
                maxHeight: parseHeight(theme, maxHeight)
            },
            width !== undefined && {
                width: parseWidth(theme, width)
            },
            minWidth !== undefined && {
                minWidth: parseWidth(theme, minWidth)
            },
            maxWidth !== undefined && {
                maxWidth: parseWidth(theme, maxWidth)
            }
        ];
}

export { size };
//# sourceMappingURL=size.js.map
